import _ from 'lodash'
import log from 'loglevel'

import config from '../../config'

import { LOG_ACTION, LOG_ACTION_REQUEST } from './constants'

export function logAction(options) {
    return {
        type: LOG_ACTION,
        data: {
            options,
        },
    }
}

export function logActionRequest(sessionId, options) {
    const o = _.merge(
        {
            action_cd: options.actionCd || '', // eslint-disable-line camelcase
            module_cd: options.moduleCd || '', // eslint-disable-line camelcase
            note: '',
            parameters: {},
        },
        options
    )

    if (_.isEmpty(o.action_cd) || _.isEmpty(o.module_cd)) {
        log.warn('logAction: action_cd and module_cd are mandatory!')
    }

    const formData = `action_cd=${o.action_cd}&module_cd=${o.module_cd}&note=${o.note}&parameters=${JSON.stringify(
        o.parameters
    )}`

    return {
        type: LOG_ACTION_REQUEST,
        payload: {
            ...config.api.logAction,
            formData,
            headers: {
                sid: sessionId,
                Accept: 'text/plain',
                'content-type': 'application/x-www-form-urlencoded',
            },
        },
    }
}
